import React from 'react';
import { AlertDialog, Content, Divider, Link, View, } from '@adobe/react-spectrum';
import { Flex } from '@react-spectrum/layout';
import { TwitterHandle } from 'app/assets/brands/Twitter';
import { Text } from 'app/views/components/typography/Text';
import { Version } from 'app/utils/version';
const Dependencies = [
    { name: 'React', url: 'https://reactjs.org' },
    { name: 'Redux', url: 'https://redux.js.org' },
    { name: 'Redux Toolkit', url: 'https://redux-toolkit.js.org' },
    { name: 'React Spectrum', url: 'https://github.com/adobe/react-spectrum' },
    { name: 'Quill', url: 'https://quilljs.com/' },
    { name: 'ProseMirror', url: 'https://prosemirror.net/' },
    { name: 'SimpleIcons', url: 'https://simpleicons.org/' },
    { name: 'Sentry', url: 'https://sentry.io/' },
    { name: 'Vercel', url: 'https://vercel.com/' },
];
export const AboutDialog = () => (React.createElement(AlertDialog, { variant: "information", title: "Some random info", primaryActionLabel: "Close" },
    React.createElement(Content, null,
        React.createElement(Text, { tag: "p" }, "Annotely (prev. szoter) was initialy developed with Adobe Flex and created as a side project in 2010."),
        React.createElement(Text, { tag: "p" },
            "Yes! It's online for ",
            React.createElement("b", null, "over 10 years"),
            " now \uD83C\uDF89"),
        React.createElement(Text, { tag: "p" }, "You are using a 3rd iteration of this project."),
        React.createElement(Text, { tag: "p" },
            "You can reach out to me",
            ' ',
            React.createElement(Link, null,
                React.createElement("a", { href: "/contact", target: "_blank", rel: "noreferrer" }, "here"))),
        React.createElement(Divider, { orientation: "horizontal", size: "S", marginY: "size-50" }),
        React.createElement(Text, { tag: "p", size: "S" }, "Built with"),
        React.createElement(View, null, Dependencies.map(dep => (React.createElement(Link, { key: dep.url, marginEnd: "size-50" },
            React.createElement("a", { href: dep.url, target: "_blank", rel: "noreferrer" }, dep.name))))),
        React.createElement(View, null,
            "Fonts:",
            React.createElement(Flex, { direction: "column" },
                React.createElement(View, null,
                    React.createElement(Link, null,
                        React.createElement("a", { href: "https://virgil.excalidraw.com/" }, "Virgil"))),
                React.createElement(View, null,
                    React.createElement(Link, null,
                        React.createElement("a", { href: "https://github.com/microsoft/cascadia-code" }, "Cascadia Code"))))),
        React.createElement(Divider, { orientation: "horizontal", size: "S", marginY: "size-50" }),
        React.createElement(Text, { tag: "p", size: "S" }, Version.version),
        React.createElement(Text, { tag: "p", size: "XS" },
            Version.date,
            " \u0263 @ ",
            Version.branch),
        React.createElement(Text, { tag: "p", size: "XS" }, Version.commit),
        React.createElement(Divider, { orientation: "horizontal", size: "S", marginY: "size-50" }),
        React.createElement(Flex, { justifyContent: "end" },
            "Built by\u00A0\u00A0",
            React.createElement("a", { href: "https://twitter.com/z2plusc", target: "_blank", rel: "noreferrer", style: { textDecoration: 'none' } },
                React.createElement(TwitterHandle, { handle: "Matt" }))),
        React.createElement(Flex, { justifyContent: "end" },
            React.createElement("a", { href: "https://twitter.com/annotely", target: "_blank", rel: "noreferrer", style: { textDecoration: 'none' } },
                React.createElement(TwitterHandle, { handle: "annotely" }))))));
